var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pp-modal",
    {
      attrs: { "mask-closable": false, width: "1000" },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c(
        "p",
        { staticClass: "modalHead", attrs: { slot: "header" }, slot: "header" },
        [_c("span", [_vm._v("修改账户信息")])]
      ),
      _c(
        "div",
        { staticClass: "modalContent" },
        [
          _c(
            "pp-row",
            [
              _c(
                "pp-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "pp-form",
                    {
                      ref: "ruleForm",
                      staticClass: "bankInfo-title",
                      attrs: {
                        model: _vm.updateBankinfo,
                        rules: _vm.rules,
                        "label-position": "left",
                        "label-width": 140,
                        inline: "",
                      },
                    },
                    [
                      _c(
                        "pp-form-item",
                        {
                          staticClass: "bankInfo-item ",
                          attrs: { label: "账号币种:", prop: "currency" },
                        },
                        [
                          _c(
                            "pp-select",
                            {
                              staticStyle: { width: "160px" },
                              model: {
                                value: _vm.updateBankinfo.currency,
                                callback: function ($$v) {
                                  _vm.$set(_vm.updateBankinfo, "currency", $$v)
                                },
                                expression: "updateBankinfo.currency",
                              },
                            },
                            _vm._l(_vm.currencyList, function (item) {
                              return _c(
                                "pp-option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(" " + _vm._s(item.label) + " ")]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c("pp-line", {
                        staticClass: "bankInfo-line",
                        staticStyle: { margin: "0 0 20px 0" },
                        attrs: { width: "100%" },
                      }),
                      _c(
                        "pp-form-item",
                        { attrs: { label: "企业名称:" } },
                        [
                          _c("pp-input", {
                            staticStyle: { width: "282px" },
                            attrs: { disabled: true, placeholder: "企业名称" },
                            model: {
                              value: _vm.authentication,
                              callback: function ($$v) {
                                _vm.authentication = $$v
                              },
                              expression: "authentication",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "pp-form-item",
                        { attrs: { label: "企业英文名称:" } },
                        [
                          _c("pp-input", {
                            staticStyle: { width: "282px" },
                            attrs: {
                              disabled: true,
                              placeholder: "企业英文名称",
                            },
                            model: {
                              value: _vm.companyEnglishName,
                              callback: function ($$v) {
                                _vm.companyEnglishName = $$v
                              },
                              expression: "companyEnglishName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("pp-line", {
                        staticClass: "bankInfo-line",
                        staticStyle: { margin: "0 0 20px 0" },
                        attrs: { width: "100%" },
                      }),
                      _c(
                        "pp-form-item",
                        { attrs: { label: "银行名称:", prop: "bankName" } },
                        [
                          _c("pp-input", {
                            staticStyle: { width: "282px" },
                            attrs: { placeholder: "银行名称", maxlength: 255 },
                            model: {
                              value: _vm.updateBankinfo.bankName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.updateBankinfo,
                                  "bankName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "updateBankinfo.bankName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "pp-form-item",
                        { attrs: { label: "银行卡号:", prop: "cardNo" } },
                        [
                          _c("pp-input", {
                            staticStyle: { width: "282px" },
                            attrs: { placeholder: "银行卡号", maxlength: 64 },
                            model: {
                              value: _vm.updateBankinfo.cardNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.updateBankinfo,
                                  "cardNo",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "updateBankinfo.cardNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "pp-form-item",
                        {
                          attrs: {
                            label: "支行名称（国内）:",
                            prop: "branchInfo",
                          },
                        },
                        [
                          _c("pp-input", {
                            staticStyle: { width: "282px" },
                            attrs: { placeholder: "支行名称", maxlength: 255 },
                            model: {
                              value: _vm.updateBankinfo.branchInfo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.updateBankinfo,
                                  "branchInfo",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "updateBankinfo.branchInfo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "pp-form-item",
                        { attrs: { label: "银行代码", prop: "swiftCode" } },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "line-height": "18px",
                                "margin-top": "-12px",
                                display: "inline-block",
                              },
                              attrs: { slot: "label" },
                              slot: "label",
                            },
                            [
                              _vm._v("Swift代码: "),
                              _c(
                                "a",
                                {
                                  staticClass: "acla",
                                  staticStyle: { display: "block" },
                                  attrs: {
                                    href: "https://www2.swift.com/bsl/index.faces",
                                    maxlength: 64,
                                    target: "_blank",
                                  },
                                },
                                [_vm._v("查询Swift Code")]
                              ),
                            ]
                          ),
                          _c("pp-input", {
                            staticStyle: { width: "282px" },
                            attrs: { placeholder: "Swift代码", maxlength: 64 },
                            model: {
                              value: _vm.updateBankinfo.swiftCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.updateBankinfo,
                                  "swiftCode",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "updateBankinfo.swiftCode",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "pp-form-item",
                        { attrs: { label: "银行代码:", prop: "bankCode" } },
                        [
                          _c("pp-input", {
                            staticStyle: { width: "282px" },
                            attrs: { placeholder: "银行代码", maxlength: 64 },
                            model: {
                              value: _vm.updateBankinfo.bankCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.updateBankinfo,
                                  "bankCode",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "updateBankinfo.bankCode",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "pp-form-item",
                        {
                          attrs: {
                            label: "开户支行地址:",
                            prop: "bankAddress",
                          },
                        },
                        [
                          _c("pp-input", {
                            staticStyle: { width: "719px" },
                            attrs: {
                              placeholder: "开户支行地址",
                              maxlength: 255,
                            },
                            model: {
                              value: _vm.updateBankinfo.bankAddress,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.updateBankinfo,
                                  "bankAddress",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "updateBankinfo.bankAddress",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "pp-form-item",
                        {
                          attrs: {
                            label: "联系人手机号:",
                            prop: "reservedPhoneNo",
                          },
                        },
                        [
                          _c("pp-input", {
                            staticStyle: { width: "282px" },
                            attrs: { placeholder: "联系人手机", maxlength: 64 },
                            model: {
                              value: _vm.updateBankinfo.reservedPhoneNo,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.updateBankinfo,
                                  "reservedPhoneNo",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "updateBankinfo.reservedPhoneNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("pp-line", {
                        staticClass: "bankInfo-line",
                        staticStyle: { margin: "0 0 20px 0" },
                        attrs: { width: "100%" },
                      }),
                      _c(
                        "pp-form-item",
                        { attrs: { label: "绑定手机号:" } },
                        [
                          _c("pp-input", {
                            staticStyle: { width: "282px" },
                            attrs: {
                              disabled: true,
                              placeholder: "绑定手机号",
                            },
                            model: {
                              value: _vm.updateBankinfo.phoneNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.updateBankinfo, "phoneNo", $$v)
                              },
                              expression: "updateBankinfo.phoneNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "pp-form-item",
                        {
                          staticClass: "verifycodebox",
                          attrs: { label: "安全验证码:", prop: "verifyCode" },
                        },
                        [
                          _c("pp-input", {
                            staticStyle: { width: "282px" },
                            attrs: { placeholder: "安全验证码" },
                            model: {
                              value: _vm.updateBankinfo.verifyCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.updateBankinfo,
                                  "verifyCode",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "updateBankinfo.verifyCode",
                            },
                          }),
                          _c(
                            "pp-button",
                            {
                              staticClass: "codebox",
                              attrs: { size: "spec", loading: _vm.codeState },
                              on: { click: _vm.SetPhoneCode },
                            },
                            [
                              !_vm.codeState
                                ? _c("span", [_vm._v("获取验证码")])
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.codeTime2) + "秒可重新发送"
                                    ),
                                  ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { "text-align": "right" },
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "pp-button",
            {
              attrs: { size: "spec" },
              on: {
                click: function ($event) {
                  return _vm.cancle()
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "pp-button",
            {
              attrs: { type: "primary", size: "spec", loading: _vm.loading2 },
              on: {
                click: function ($event) {
                  return _vm.updatefun()
                },
              },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }